import { CurrencyItem } from '../types';

import cn from '../styles.module.css';

const formatCurrenciesList = (list: CurrencyItem[]): CurrencyItem[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};
    render.shouldCreateBalanceForClients = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.shouldCreateBalanceForClients ? 'Available' : 'Unavailable'}
      </div>
    );
    render.active = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.active ? 'Active' : 'Disabled'}
      </div>
    );

    render.code = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.code || '-'}
      </div>
    );
    render.name = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.name}
      </div>
    );
    render.description = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.description}
      </div>
    );
    render.decimals = (
      <div className={!result.active ? cn.disabledField : ''}>
        {result.decimals}
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCurrenciesList;
